import { createContext, use } from 'react';
import type { Translator } from './types';

export const TranslatorContext = createContext<Translator>(() => {
    throw new Error('TranslatorContext provider is missing.');
});

export const useTranslator = () => use(TranslatorContext);
